import type {RouteRecordRaw} from 'vue-router';
import {pagesPath} from '@/ts/router/pages-path';
import InterventionFetchPage from '@/vue/pages/interventions/intervention-fetch-page.vue';
import InterventionSessionPage from '@/vue/pages/interventions/intervention-session-page.vue';
import InterventionSessionCompletedPage from '@/vue/pages/interventions/intervention-session-completed-page.vue';

/** Route definitions for intervention session playback (active session page and session-completed page). */
export const sessionPages: RouteRecordRaw[] = [
  {
    path: pagesPath.session.sessionWrapper,
    component: InterventionFetchPage,
    meta: {
      disablePageScrollingInTemplate: true,
      medicalDevice: true,
    },
    children: [
      {
        path: pagesPath.session.sessionPage,
        component: InterventionSessionPage,
        meta: {
          medicalDevice: true,
        },
      },
      {
        path: pagesPath.session.sessionCompletedPage,
        component: InterventionSessionCompletedPage,
        meta: {
          medicalDevice: true,
        },
      },
    ],
  },
];



